import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import react_intersection_observer from "@researchgate/react-intersection-observer";
const Lazyload = ({ children, style, placeholder, observerOptions, wrapperClassName, onVisible })=>{
    const [isVisbile, setIsVisible] = useState(false);
    const handleIntersection = (event)=>{
        const { isIntersecting } = event;
        if (isIntersecting) {
            setIsVisible(true);
            if (onVisible) onVisible();
        }
    };
    const options = {
        onChange: handleIntersection,
        rootMargin: '0px 0px 300px 0px',
        disabled: isVisbile
    };
    return /*#__PURE__*/ jsx(react_intersection_observer, {
        ...options,
        ...observerOptions,
        children: /*#__PURE__*/ jsx("div", {
            className: wrapperClassName,
            style: {
                ...style
            },
            children: isVisbile ? children : placeholder || /*#__PURE__*/ jsx("div", {})
        })
    });
};
const Lazyload_Lazyload = Lazyload;
export default Lazyload_Lazyload;
